module.exports = __webpack_public_path__ + "static/farm-9c7bce5c8a8903cbccef05c82ba5827e.svg";